import { render, staticRenderFns } from "./loginWithJAccount.vue?vue&type=template&id=32d87c46&scoped=true&"
import script from "./loginWithJAccount.vue?vue&type=script&lang=ts&"
export * from "./loginWithJAccount.vue?vue&type=script&lang=ts&"
import style0 from "./loginWithJAccount.vue?vue&type=style&index=0&id=32d87c46&prod&lang=scss&scoped=true&"
import style1 from "./loginWithJAccount.vue?vue&type=style&index=1&id=32d87c46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d87c46",
  null
  
)

export default component.exports